import React from "react";
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import CartService from '../../services/CartService';
export default function GridCard(props) {

    const { languageCode,
        pdpWildcardBaseUrlPartial,
        addToCardApi,
        itemListName,
        PlaceholderImage,
        MsrpText,
        Productindex,
        successAddToCart,
        failureAddToCart,
        viewCartLabel,
        viewCartUrl,
        StartingAtText,
        addtoCartLabel,
        ViewDetailsLabel,
        productNumberLabel,
        product: {
            Sku,
            UrlSegment,
            MediumImagePath,
            AltText,
            ShortDescription,
            ERPNumber,
            ERPDescription,
            IsStyleProductParent,
            ProductGroupMSRP,
            IsPart,
            modelMSRP,
            Pricing,
            AllowedAddToCart,
            CanAddToCart,
            UnitOfMeasure,
            currencyCode,
            OverlayRibbon
        }
    } = props;

    const url = `/${languageCode}${pdpWildcardBaseUrlPartial}/${UrlSegment}`

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const handleImageError = function (e) {
        e.target.onerror = null;
        e.target.src = PlaceholderImage;
    }
    const  setCookie =(name, value, eDate, domain) => {
        var date = new Date(Date.parse(eDate));
        var expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + (value || "") + expires + ";domain=" + domain + "; path=/";
    }
    const handleAddToCart = () => {
        const res = CartService.AddtoCard({
          languageCode,
          Sku,
          UnitOfMeasure,
          addToCardApi
        }).then((res) => {
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              items: [{
                item_name:ShortDescription, // Name or ID is required.
                item_id: Sku,
                price: Pricing.ActualPrice ,
                currency :currencyCode,
                  item_list_name: itemListName,
                index: Productindex,
                quantity: 1
              }]
            }
            });
            if (res.data.CookieCollection) {
                var cookies = res.data.CookieCollection;
                cookies.forEach((cookie) => {
                    setCookie(cookie.Name, cookie.Value, cookie.Expires, cookie.Domain);
                })
            }
            if (res.data.TotalItems >= 0) {
                $(".header__cart-items").removeAttr("style");
                $('.header__cart-items').text(res.data.TotalItems);
               handleShow();
               setMessage(res.data.Message);
               setStatus(successAddToCart);
            }
            else
            {
                handleShow();
                setMessage(res.data.Message);
                setStatus(failureAddToCart);
            }
  
        }).catch((err) => {
          console.log(err)
        })
      }

    return (
        <div className="grid-card">
            <a href={url}>
                <img src={MediumImagePath} alt={AltText} onError={handleImageError} />
            </a>
            {OverlayRibbon && OverlayRibbon !== "" ? (
                <div className="card-sticker">{OverlayRibbon}</div>
            ) : null}
            <div className="grid-card-content">
                <a href={url}>
                    <p className="card-title" dangerouslySetInnerHTML={{ __html: ShortDescription }}></p>
                </a>
                {
                    IsStyleProductParent ?
                        null
                        :
                        <p>{productNumberLabel} <strong>{ERPNumber}</strong></p>
                }               
                {
                    ERPDescription != null ?
                        <p className="card-tertiary-title" dangerouslySetInnerHTML={{ __html: ERPDescription }}></p>
                        :
                        null
                }
             
                {
                    IsStyleProductParent ?
                        ProductGroupMSRP > 0 ? <p className="card-price spacer">  <small>{StartingAtText} </small>
                            <strong>{ProductGroupMSRP.toLocaleString(undefined, {style:'currency', currency:'USD'})} </strong><small>{MsrpText}</small>
                        </p>
                            : null
                        : Pricing.RegularPrice > 0 ? <p className="card-price spacer">
                                <strong>{Pricing.RegularPrice.toLocaleString(undefined, {style:'currency', currency:'USD'})} </strong><small>{MsrpText}</small>
                            </p> :
                            modelMSRP > 0 ? <p className="card-price spacer">  <small>{StartingAtText} </small>
                                <strong>{modelMSRP.toLocaleString(undefined, {style:'currency', currency:'USD'})} </strong><small>{MsrpText}</small>
                            </p> : null
                }
            </div>

            {
                IsStyleProductParent ?
                    <a href={url} className="btn btn-secondary btn-secondary--sm">{ViewDetailsLabel}</a>
                    :
                    Pricing.RegularPrice > 0 ?
                        AllowedAddToCart && CanAddToCart ?
                            <button className="btn btn-secondary btn-secondary--sm"  onClick={handleAddToCart}>{addtoCartLabel}</button>
                            :
                            <a href={url} className="btn btn-secondary btn-secondary--sm">{ViewDetailsLabel}</a>
                        : <a href={url} className="btn btn-secondary btn-secondary--sm">{ViewDetailsLabel}</a>
            }
        <Modal show={show} onHide={handleClose}>
        <Modal.Header>
                    <h4 className="modal-title">{status}</h4>
                    <button type="button" className="close" onClick={handleClose}><i className="fa fa-close" /></button>
        </Modal.Header>
        <Modal.Body>
            <p>{message}</p>
            <div><h5><a href={viewCartUrl} >{viewCartLabel}</a></h5></div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
        </div>

    );
}